"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentifierNamesCacheFileUtils = void 0;
const fs = __importStar(require("fs"));
const path = __importStar(require("path"));
const JavaScriptObfuscatorCLI_1 = require("../JavaScriptObfuscatorCLI");
class IdentifierNamesCacheFileUtils {
    constructor(identifierNamesCachePath) {
        this.identifierNamesCachePath = identifierNamesCachePath;
    }
    static isValidFilePath(filePath) {
        try {
            return fs.statSync(filePath).isFile()
                && path.extname(filePath) === IdentifierNamesCacheFileUtils.identifierNamesCacheExtension;
        }
        catch (_a) {
            return false;
        }
    }
    static readFile(filePath) {
        return {
            filePath: path.normalize(filePath),
            content: fs.readFileSync(filePath, JavaScriptObfuscatorCLI_1.JavaScriptObfuscatorCLI.encoding)
        };
    }
    readFile() {
        if (!this.identifierNamesCachePath) {
            return null;
        }
        if (!IdentifierNamesCacheFileUtils.isValidFilePath(this.identifierNamesCachePath)) {
            throw new ReferenceError(`Given identifier names cache path must be a valid ${IdentifierNamesCacheFileUtils.identifierNamesCacheExtension} file path`);
        }
        const fileData = IdentifierNamesCacheFileUtils.readFile(this.identifierNamesCachePath);
        if (!fileData.content) {
            return {};
        }
        try {
            return JSON.parse(fileData.content);
        }
        catch (_a) {
            throw new ReferenceError('Identifier names cache file must contains a json dictionary with identifier names');
        }
    }
    writeFile(identifierNamesCache) {
        if (!this.identifierNamesCachePath) {
            return;
        }
        const identifierNamesCacheJson = JSON.stringify(identifierNamesCache);
        fs.writeFileSync(this.identifierNamesCachePath, identifierNamesCacheJson, {
            encoding: JavaScriptObfuscatorCLI_1.JavaScriptObfuscatorCLI.encoding
        });
    }
}
exports.IdentifierNamesCacheFileUtils = IdentifierNamesCacheFileUtils;
IdentifierNamesCacheFileUtils.identifierNamesCacheExtension = '.json';
